import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {
  Title,
  LeftSide,
  Column,
  Back,
  InputContainer,
  UnderlineText,
  StyledColumn,
  StyledText,
} from './VerificationCodePage.styles';
import Button from '../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../assets/icons/logoBlack.svg';
import { ReactComponent as LeftChevron } from '../../../assets/icons/chevronLeft.svg';
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import MainContainer from '../../../components/MainContainer/MainContainer';
import { useDispatch, useSelector } from 'react-redux';
import { renewCodeForVendor, signUp } from '../../../store/slice/auth/asyncThunks';
import { notifyError } from '../../../utils/notify';
import { selectCreateAccountPending, selectEmailInput, selectPasswordInput } from '../../../store/slice/auth/slice';
import { RENEW_CODE_TYPE } from '../../../utils/constants';

const VerificationCodePage = () => {
  const [otp, setOtp] = useState('');
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const password = useSelector(selectPasswordInput);
  const email = useSelector(selectEmailInput);
  const loading = useSelector(selectCreateAccountPending);
  const [timer, setTimer] = useState(60);
  const [canResendCode, setCanResendCode] = useState(true);
  const [timerText, setTimerText] = useState('60 seconds');

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
        setTimerText(`${timer - 1} seconds`);
      }, 1000);
    } else {
      setCanResendCode(true);
      setTimerText('Resend Code');
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleResendCode = () => {
    dispatch(renewCodeForVendor({ email, type: RENEW_CODE_TYPE.EMAIL_VERIFICATION }));
    setTimer(60);
    setTimerText('60 seconds');
    setCanResendCode(false);
  };
  const onNextStep = () => {
    dispatch(signUp({ email, password, code: otp }))
      .unwrap()
      .then(() => {
        navigation({
          pathname: '/sign-up',
          search: `?step=1`,
        });
      })
      .catch(err => notifyError(err.message));
  };

  const startTimer = () => {
    if (canResendCode) {
      setTimer(60);
      setCanResendCode(false);
    }
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      onNextStep();
    }
  };

  useEffect(() => {
    document.addEventListener('keypress', handleKeyPress);

    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, [handleKeyPress]);

  useEffect(() => {
    startTimer();
  }, []);

  return (
    <MainContainer>
      <LeftSide>
        <Logo width={110} height={58} />

        <Column>
          <Back onClick={() => navigation(-1)}>
            <LeftChevron />
          </Back>
          <Title>Verification code</Title>
        </Column>
        <InputContainer>
          <OtpInput
            containerStyle={{ flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}
            inputStyle={{
              width: 55,
              userSelect: 'none',
              height: 51,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 12,
              fontSize: 18,
              fontFamily: 'Poppins-Medium',

              letterSpacing: -0.2,
              color: '#000',
              borderTopWidth: 0,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderBottomWidth: 1,
              borderColor: '#000',
              outline: 'none',
              backgroundColor: '#fff',
            }}
            shouldAutoFocus
            value={otp}
            placeholder={'------'}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span style={{ userSelect: 'none', color: 'transparent' }}>-</span>}
            renderInput={props => <input {...props} />}
          />
          <StyledColumn>
            <UnderlineText onClick={canResendCode ? handleResendCode : null} $timer={canResendCode}>
              Didn't get the code?
            </UnderlineText>
            <StyledText $timer={canResendCode}>{timerText}</StyledText>
          </StyledColumn>
        </InputContainer>

        <Button
          disabled={otp.length !== 6 || loading}
          loading={loading}
          title={'Continue'}
          onClick={onNextStep}
          width
        />
      </LeftSide>
    </MainContainer>
  );
};

export default VerificationCodePage;
